import React from 'react';
import { Skeleton } from '../common/Skeleton';

/**
 * Content-shaped placeholder for `Appointments`. Matches the rendered
 * layout (header + "New" button, Upcoming + Past sections, a 1/2-col
 * card grid) so the swap to real data doesn't reflow the page.
 */
const AppointmentCardSkeleton: React.FC = () => (
  <div className="portal-card p-4 flex items-start gap-4">
    <Skeleton className="size-16 rounded-2xl shrink-0" />
    <div className="flex-1 min-w-0 flex flex-col gap-1.5">
      <Skeleton className="h-4 w-2/5" />
      <Skeleton className="h-3 w-3/5" />
      <Skeleton className="h-4 w-1/2 mt-1" />
      <Skeleton className="h-3 w-16" />
    </div>
  </div>
);

const AppointmentsSkeleton: React.FC = () => (
  <div className="flex flex-col gap-5" role="status" aria-label="Loading appointments">
    {/* Header row matching the real header */}
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0 flex flex-col gap-2">
        <Skeleton className="h-7 w-48" />
        <Skeleton className="h-4 w-56" />
      </div>
      <Skeleton className="h-9 w-20 rounded-full shrink-0" />
    </div>

    {/* Upcoming section */}
    <section className="flex flex-col gap-3">
      <Skeleton className="h-3 w-20" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <AppointmentCardSkeleton />
        <AppointmentCardSkeleton />
      </div>
    </section>

    {/* Past section */}
    <section className="flex flex-col gap-3">
      <Skeleton className="h-3 w-12" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <AppointmentCardSkeleton />
        <AppointmentCardSkeleton />
        <AppointmentCardSkeleton />
        <AppointmentCardSkeleton />
      </div>
    </section>

    <span className="sr-only">Loading appointments…</span>
  </div>
);

export default AppointmentsSkeleton;
